// src/plugins/dayjs.js
import dayjs from 'dayjs'

// Import Plugins
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

// Import Locales
import 'dayjs/locale/ar'

export default {
    install: (app, options) => {
        // 1. Configure Dayjs
        dayjs.extend(relativeTime)
        dayjs.extend(utc)
        dayjs.extend(timezone)

        // Set default locale (you can pass this as an option if you want)
        // Defaulting to Arabic ('ar') based on your audience
        const defaultLocale = options?.locale || 'ar'
        dayjs.locale(defaultLocale)

        // 2. Add Global $dayjs property
        // This allows this.$dayjs in your components
        app.config.globalProperties.$dayjs = dayjs

        // 3. (Optional) Add a Global Helper for Standard Formatting
        // Usage in template: {{ $formatDate(user.created_at) }}
        app.config.globalProperties.$formatDate = (date, format = 'DD/MM/YYYY h:mm A') => {
            if (!date) return '---'
            return dayjs(date).format(format)
        }
        app.config.globalProperties.$toLocal = (date, format = 'DD/MM/YYYY h:mm A') => {
            if (!date) return '---'

            // LOGIC EXPLAINED:
            // 1. dayjs.utc(date): "Take this string and assume it is UTC, even if it doesn't have a 'Z' at the end."
            // 2. .local(): "Convert that UTC time to the user's browser timezone."
            // 3. .format(): "Make it readable."
            return dayjs(date).local().format(format)
        }

        // 4. (Optional) Provide it for Composition API (inject/provide)
        // In case you mix Options API with Composition API later
        app.provide('dayjs', dayjs)
    }
}